export default __webpack_public_path__ + "static/media/rating_3.c8ca8fec.svg";